export { default } from './ManagersTabContent';
